import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'lum-sales-order-picklist-confirm-action',
  templateUrl: './sales-order-picklist-confirm-action.component.html',
  styleUrls: ['./sales-order-picklist-confirm-action.component.scss'],
})
export class SalesOrderPicklistConfirmActionComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data :{
      orders :{
        orderNumber :string;
        message :string;
        picklistId :number;
      };
    },
  ) {}

  ngOnInit() :void {}
}
